import { render, staticRenderFns } from "./manicure.vue?vue&type=template&id=7f9697a8&scoped=true"
import script from "./manicure.vue?vue&type=script&lang=js"
export * from "./manicure.vue?vue&type=script&lang=js"
import style0 from "./manicure.vue?vue&type=style&index=0&id=7f9697a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9697a8",
  null
  
)

export default component.exports